import { Icon, type IconName } from "components/Icon";
import { StatusChip, type StatusChipVariant } from "features/shared/components/StatusChip";
import type { ReactNode } from "react";
import { cn } from "utils/styling";

type EnergyAnalysisConfigChipProps = {
  className?: string;
  iconName?: IconName;
  label: ReactNode;
  variant: StatusChipVariant;
};

export const EnergyAnalysisConfigChip = ({ className, iconName, label, variant }: EnergyAnalysisConfigChipProps) => (
  <StatusChip className={cn("rounded-full border-none", className)} variant={variant}>
    {iconName ? <Icon className="h-[1.2rem] w-[1.2rem]" color="currentColor" iconName={iconName} /> : null}
    <span>{label}</span>
  </StatusChip>
);
